// @LTG-ID: data-faq
// @STATUS: BUILT @SHARED
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-019, source Landing Page.html lines 2799-2828
// @CHANGED: 2026-02 session_003 (CHG-0048)
// @OWNER: web
//
// 7 productized-purchase FAQs. Copy is legal/editorial-grade — do NOT paraphrase.

export const FAQ = [
    {
        q: "Is this an AI-generated report?",
        a: "No. The Strategic Snapshot is not AI-generated. It is a productized methodology built and signed by KGOB CPAs & Advisors over thirty-eight years of valuation work. The model that applies the methodology is computational, in the same way a CPA's tax software is computational, but the analytical framework, the multiple ranges, the lever-scoring logic, and the recommendation tree are all human-built and human-reviewed. Under AICPA SSVS No. 1 \u00B69, this puts the report in the standard's exclusion for mechanical computations. The output is an indicative valuation produced by a CPA firm, not a chatbot, and not a generative-AI summary of public data.",
    },
    {
        q: "What if my industry isn't well-covered in your data?",
        a: "We cover 18 industries today. At intake, you'll tell us yours. If your sector falls outside what our valuation models cover, we flag it before charging your card and either quote you a custom Snapshot at the same $995. We'll tell you before you're charged.",
    },
    {
        q: "Can I share the report with my partner, banker, or accountant?",
        a: "Yes. You're buying the PDF outright \u2014 share it freely with your team, board, lender, or attorney. The valuation methodology is documented page-by-page, so a third party can verify our work without calling us first.",
    },
    {
        q: "What happens after delivery if I have questions?",
        a: "Every Snapshot includes one round of written Q&A with Sara, by email, with a 3-business-day response window. For ongoing dialogue, the Growth Membership ($95/mo, available after your Snapshot) keeps the line open with written expert consultations as part of the subscription.",
    },
    {
        q: "Refund policy?",
        a: "See our Refund Policy page for the full terms — eligibility, process, and timing. The Strategic Snapshot is an indicative valuation, not a recommendation or a guarantee of outcome.",
    },
    {
        q: "How is this different from a Big-Four valuation?",
        a: "A formal Big-Four certified valuation runs $15,000\u2013$50,000 and takes 6\u201310 weeks. The Strategic Snapshot is faster, leaner, and signed by a Managing Partner CPA \u2014 it's what most owner-operated businesses actually need to make their next move, at roughly 5% of the cost. If you need a formal certified valuation for an SBA loan or litigation, we'll tell you, and we'll quote that separately.",
    },
    {
        q: "Do you take on advisory clients outside the Membership?",
        a: "Rarely. We've built KGOB around productized deliverables \u2014 Snapshot and Membership \u2014 specifically so we can serve more owners well. Custom scopes, sector deep-dives, and in-office consultations are available to Snapshot owners on request, billed separately as extras.",
    },
];
